import React from 'react';
import { cn } from '@/lib/utils';

type IconProps = {
  icon: number;
  className?: string;
  marginX?: string;
  marginY?: string;
};

const ICON_SIZE = 16;
const SPRITE_COLUMNS = 30;
const AritoIcon: React.FC<IconProps> = ({ icon, className, marginX, marginY }) => {
  const row = Math.floor((icon - 1) / SPRITE_COLUMNS);
  const col = (icon - 1) % SPRITE_COLUMNS;
  const backgroundPosition = `-${col * ICON_SIZE}px -${row * ICON_SIZE}px`;
  const isInverted = className?.includes('invert');

  return (
    <div
      className={cn('inline-block size-[16px] bg-no-repeat', className)}
      style={{
        backgroundImage: 'url(/images/all_icon_1.png)',
        backgroundPosition,
        marginLeft: marginX,
        marginRight: marginX,
        marginTop: marginY,
        marginBottom: marginY,
        ...(isInverted && { filter: 'invert(1)' })
      }}
    />
  );
};

export default AritoIcon;
